import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../../../environments/environment';
import { TransactionsService } from '../../../../core/services/transactions/transactions.service';
import { TransactionsQuery } from '../../../../core/services/transactions/transactions.model';
import { TRANS_STATUS } from '../../../../core/services/transactions/transaction.constants';

@Injectable()
export class TransacsService implements Resolve<any>
{
  transactions: any[] = [];
  onTransactionsChanged: BehaviorSubject<any> = new BehaviorSubject({});

  constructor(
      private http: HttpClient,
      private readonly transactionsService: TransactionsService,
  ) {}

  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    // return new Promise((resolve, reject) => {
    //   Promise.all([
    //       this.getTransactions()
    //   ]).then(
    //       () => {
    //           resolve();
    //       },
    //       reject
    //   );
    // });
    return Promise.resolve(true);
  }

  getTransactions(
    query: TransactionsQuery = {
        statut: TRANS_STATUS.AUTHORISED,
    }
  ): Promise<any> {
    return new Promise((resolve, reject) => {
        this.transactionsService.list(query)
            .subscribe((response: any) => {
                this.transactions = response;
                this.onTransactionsChanged.next(this.transactions);
                resolve(response);
            }, reject);
    });
  }

  getStatusClass(val: string) {
      return this.transactionsService.getStatusClass(val);
  }


}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/transactions/transacs.service.ts